import React, { useContext, useState } from 'react'
import { QuizContext } from '../contexts/QuizContext'

const Test = () => {

	const [answered, setAnswered] = useState(false)
	const [answeredanswer, setAnsweredanswer] = useState('')

	const quizContext = useContext(QuizContext)
	//console.log("questions", quizContext.questions)
	// if ( quizContext.questions.length ) {
	// 	console.log("Answer", quizContext.questions[quizContext.curQuestion-1].correct_answer)
	// }

	const treatText = (intext) => {
		return intext.replace(/&#039;/g,"'").replace(/&quot;/g,"'").replace(/&amp;/g,"&").replace("&shy;", "-")
	}

	const checkAnswer = (answer) => {
		let correct_answer = quizContext.questions[quizContext.curQuestion-1].correct_answer
		setAnsweredanswer(answer)
		// console.log("You Answered: ", answer)
		// console.log("The Correct Answer: ", correct_answer)
		if ( answer === correct_answer ) {
			quizContext.setScore(prev => prev + 1)
		}
		setAnswered(true)
	}

	const nextQuestion = () => {
		if ( quizContext.curQuestion < 10 ) {
			quizContext.setCurQuestion(prev => prev + 1)
		}
		setAnswered(false)
	}

	return (

		<div className="testarea">
			{ quizContext.questions.length > 0 ?
			<div className="quizcontainer">
				<div className="questionnumber">Question {quizContext.curQuestion} / {quizContext.maxQuestions}</div><br />

				<div className="question">Q: {treatText(quizContext.questions[quizContext.curQuestion-1].question)}</div><br /><br />

				<div className="answers">
					<button
						onClick={()=>checkAnswer(quizContext.questions[quizContext.curQuestion-1].answers[0])}
						disabled={answered}
						className={
							answered &&
								(quizContext.questions[quizContext.curQuestion-1].correct_answer
								=== quizContext.questions[quizContext.curQuestion-1].answers[0])
								&& (answeredanswer
								=== quizContext.questions[quizContext.curQuestion-1].answers[0])
							? 'button-green' : 
							answered &&
								(answeredanswer
								=== quizContext.questions[quizContext.curQuestion-1].answers[0])
								&& (answeredanswer
								!== quizContext.questions[quizContext.curQuestion-1].correct_answer)
							? 'button-red' : 
							answered &&
								(quizContext.questions[quizContext.curQuestion-1].correct_answer
								=== quizContext.questions[quizContext.curQuestion-1].answers[0])
								&& ( answeredanswer
								!== quizContext.questions[quizContext.curQuestion-1].answers[0])
							? 'button-blue' : ''							
						}
					>
							1. {quizContext.questions[quizContext.curQuestion-1].answers[0]}
					</button><br />

					<button
						onClick={()=>checkAnswer(quizContext.questions[quizContext.curQuestion-1].answers[1])}
						disabled={answered}
						className={
							answered &&
								(quizContext.questions[quizContext.curQuestion-1].correct_answer
								=== quizContext.questions[quizContext.curQuestion-1].answers[1])
								&& (answeredanswer
								=== quizContext.questions[quizContext.curQuestion-1].answers[1])
							? 'button-green' : 
							answered &&
								(answeredanswer
								=== quizContext.questions[quizContext.curQuestion-1].answers[1])
								&& (answeredanswer
								!== quizContext.questions[quizContext.curQuestion-1].correct_answer)
							? 'button-red' : 
							answered &&
								(quizContext.questions[quizContext.curQuestion-1].correct_answer
								=== quizContext.questions[quizContext.curQuestion-1].answers[1])
								&& ( answeredanswer
								!== quizContext.questions[quizContext.curQuestion-1].answers[1])
							? 'button-blue' : ''							
						}
					>
							2. {quizContext.questions[quizContext.curQuestion-1].answers[1]}
					</button><br />

					<button
						onClick={()=>checkAnswer(quizContext.questions[quizContext.curQuestion-1].answers[2])}
						disabled={answered}
						className={
							answered &&
								(quizContext.questions[quizContext.curQuestion-1].correct_answer
								=== quizContext.questions[quizContext.curQuestion-1].answers[2])
								&& (answeredanswer
								=== quizContext.questions[quizContext.curQuestion-1].answers[2])
							? 'button-green' : 
							answered &&
								(answeredanswer
								=== quizContext.questions[quizContext.curQuestion-1].answers[2])
								&& (answeredanswer
								!== quizContext.questions[quizContext.curQuestion-1].correct_answer)
							? 'button-red' : 
							answered &&
								(quizContext.questions[quizContext.curQuestion-1].correct_answer
								=== quizContext.questions[quizContext.curQuestion-1].answers[2])
								&& ( answeredanswer
								!== quizContext.questions[quizContext.curQuestion-1].answers[2])
							? 'button-blue' : ''							
						}
					>
							3. {quizContext.questions[quizContext.curQuestion-1].answers[2]}
					</button><br />

					<button
						onClick={()=>checkAnswer(quizContext.questions[quizContext.curQuestion-1].answers[3])}
						disabled={answered}
						className={
							answered &&
								(quizContext.questions[quizContext.curQuestion-1].correct_answer
								=== quizContext.questions[quizContext.curQuestion-1].answers[3])
								&& (answeredanswer
								=== quizContext.questions[quizContext.curQuestion-1].answers[3])
							? 'button-green' : 
							answered &&
								(answeredanswer
								=== quizContext.questions[quizContext.curQuestion-1].answers[3])
								&& (answeredanswer
								!== quizContext.questions[quizContext.curQuestion-1].correct_answer)
							? 'button-red' : 
							answered &&
								(quizContext.questions[quizContext.curQuestion-1].correct_answer
								=== quizContext.questions[quizContext.curQuestion-1].answers[3])
								&& ( answeredanswer
								!== quizContext.questions[quizContext.curQuestion-1].answers[3])
							? 'button-blue' : ''							
						}
					>
							4. {quizContext.questions[quizContext.curQuestion-1].answers[3]}
					</button><br />
					{ answered && quizContext.curQuestion < 10 &&
						<button onClick={()=>nextQuestion()} className="nextquestion">Next Question</button>
					}
					{ answered && quizContext.curQuestion === 10 &&
						<div><br /><br />Quiz Completed .. Thank YOU!</div>
					}
				</div>
			</div>
			:
				<div>
					<center>Nothing to see HERE!</center>
				</div>
			}
		</div>
	)
}

export default Test
